import { useAuth } from '../auth/AuthContext';
import { BRAND_ASSETS } from '../branding';
import './Layout.css';

export default function Layout({ title, children }) {
  const { user, logout } = useAuth();

  return (
    <div className="layout">
      <header className="layout-header">
        <div className="layout-brand-group">
          <img className="layout-brand-icon" src={BRAND_ASSETS.iconMini} alt="" aria-hidden="true" />
          <div>
            <h1>{title}</h1>
            <p className="subtitle">VeriPlan — {user?.role_nom || 'Utilisateur'}</p>
          </div>
        </div>
        <button className="btn-outline" onClick={logout}>
          Déconnexion
        </button>
      </header>
      <main className="layout-main">{children}</main>
    </div>
  );
}
